import { ApiError } from '../api/client';
import type { ResourceClient } from '../api/resources';
import type { ResourceNode, ResourceResponse, ResourceSummary } from './types';

export function unavailableNode(summary: ResourceSummary): ResourceNode {
  return { resource: { ...summary, catalogueId: null, schemaVersion: 1, properties: {}, series: null, calculation: null, targetUrn: null, snapshot: null }, children: [], evaluation: null, unavailable: true };
}

/** Containment is a server-validated tree. References remain links and never grant access. */
export async function loadResourceTree(client: ResourceClient, resource: ResourceResponse, publicOnly: boolean): Promise<ResourceNode> {
  const children = await client.children(resource.id, publicOnly);
  const nodes = await Promise.all(children.map(async (child) => {
    try {
      return await loadResourceTree(client, await client.resolve(child.urn, publicOnly), publicOnly);
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) throw error;
      return unavailableNode(child);
    }
  }));
  let evaluation = null;
  let unavailable = false;
  if (resource.typeId === 'time-series') {
    try {
      evaluation = await client.evaluate(resource.id, publicOnly);
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) throw error;
      unavailable = true;
    }
  }
  return { resource, children: nodes, evaluation, unavailable };
}
